export var CARGAR_IMAGEN = 'PIZARRA_CARGAR_IMAGEN';
export var cargarImagen = function cargarImagen(dataURL) {
  return {
    type: CARGAR_IMAGEN,
    dataURL: dataURL
  };
};
export var ACTIVAR_EDITOR = 'PIZARRA_ACTIVAR_EDITOR';
export var activarEditor = function activarEditor() {
  return {
    type: ACTIVAR_EDITOR
  };
};
export var DESACTIVAR_EDITOR = 'PIZARRA_DESACTIVAR_EDITOR';
export var desactivarEditor = function desactivarEditor() {
  return {
    type: DESACTIVAR_EDITOR
  };
};
export var NOTIFICAR_CAMBIOS = 'PIZARRA_NOTIFICAR_CAMBIOS';
export var notificarCambios = function notificarCambios(dataURL) {
  return {
    type: NOTIFICAR_CAMBIOS,
    dataURL: dataURL
  };
};
export var SELECCIONAR_COLOR_LAPIZ = 'PIZARRA_SELECCIONAR_COLOR_LAPIZ';
export var seleccionarColorLapiz = function seleccionarColorLapiz(valor) {
  return {
    type: SELECCIONAR_COLOR_LAPIZ,
    valor: valor
  };
};
export var SELECCIONAR_GROSOR_LAPIZ = 'PIZARRA_SELECCIONAR_GROSOR_LAPIZ';
export var seleccionarGrosorLapiz = function seleccionarGrosorLapiz(valor) {
  return {
    type: SELECCIONAR_GROSOR_LAPIZ,
    valor: valor
  };
};
export var SELECCIONAR_COLOR_MARCADOR = 'PIZARRA_SELECCIONAR_COLOR_MARCADOR';
export var seleccionarColorMarcador = function seleccionarColorMarcador(valor) {
  return {
    type: SELECCIONAR_COLOR_MARCADOR,
    valor: valor
  };
};
export var SELECCIONAR_GROSOR_MARCADOR = 'PIZARRA_SELECCIONAR_GROSOR_MARCADOR';
export var seleccionarGrosorMarcador = function seleccionarGrosorMarcador(valor) {
  return {
    type: SELECCIONAR_GROSOR_MARCADOR,
    valor: valor
  };
};
export var SELECCIONAR_ALPHA_MARCADOR = 'PIZARRA_SELECCIONAR_ALPHA_MARCADOR';
export var seleccionarAlphaMarcador = function seleccionarAlphaMarcador(valor) {
  return {
    type: SELECCIONAR_ALPHA_MARCADOR,
    valor: valor
  };
};
export var SELECCIONAR_GROSOR_BORRADOR = 'PIZARRA_SELECCIONAR_GROSOR_BORRADOR';
export var seleccionarGrosorBorrador = function seleccionarGrosorBorrador(valor) {
  return {
    type: SELECCIONAR_GROSOR_BORRADOR,
    valor: valor
  };
};
export var SELECCIONAR_HERRAMIENTA = 'PIZARRA_SELECCIONAR_HERRAMIENTA';
export var seleccionarHerramienta = function seleccionarHerramienta(herramienta) {
  return {
    type: SELECCIONAR_HERRAMIENTA,
    herramienta: herramienta
  };
};